(function() {
  const PREPOPULATE_CONFIG = {
    'First name': 'firstName',
    'Last name': 'lastName',
    'Email': 'email'
  };

  function setInputValue(input, value) {
    if (!input || input.tagName !== 'INPUT') return;
    console.log(`ShopifyFormsPrepopulate: Setting value on input "${input.id || input.name}" to "${value}"`);
    
    try {
      const prototype = Object.getPrototypeOf(input);
      const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
      if (descriptor && descriptor.set) {
        descriptor.set.call(input, value);
      } else {
        input.value = value;
      }
    } catch (e) {
      input.value = value;
    }

    const eventOptions = { bubbles: true, composed: true, cancelable: true };
    input.dispatchEvent(new Event('input', eventOptions));
    input.dispatchEvent(new Event('change', eventOptions));
    input.dispatchEvent(new Event('blur', eventOptions));
  }

  function prepopulateForm(root) {
    if (!window.customerData) return false;

    const labels = Array.from(root.querySelectorAll('label'));
    let filled = 0;

    labels.forEach(label => {
      const text = label.innerText.trim();
      const configKey = Object.keys(PREPOPULATE_CONFIG).find(k => text.includes(k));
      
      if (configKey) {
        const labelId = label.id;
        // The app uses aria-labelledby to connect labels and inputs
        let input = root.querySelector(`input[aria-labelledby="${labelId}"]`);
        
        // Fallback: search in the same container
        if (!input) {
          input = label.parentElement.querySelector('input');
        }

        const dataKey = PREPOPULATE_CONFIG[configKey];
        const val = window.customerData[dataKey];
        
        if (input && val && (!input.value || input.value === '+27 ')) {
          setInputValue(input, val);
          filled++;
        }
      }
    });

    // Final fallback: search by placeholders/aria
    if (filled === 0) {
      const inputs = Array.from(root.querySelectorAll('input'));
      inputs.forEach(input => {
        const placeholder = input.getAttribute('placeholder') || '';
        const aria = input.getAttribute('aria-label') || '';
        const configKey = Object.keys(PREPOPULATE_CONFIG).find(k => 
          placeholder.includes(k) || aria.includes(k)
        );

        if (configKey) {
          const val = window.customerData[PREPOPULATE_CONFIG[configKey]];
          if (val && (!input.value || input.value === '+27 ')) {
            setInputValue(input, val);
            filled++;
          }
        }
      });
    }

    return filled > 0;
  }

  function observeShadow(el) {
    console.log('ShopifyFormsPrepopulate: Monitoring Shadow DOM...');
    
    const tryFill = () => {
      if (el.shadowRoot) {
        if (prepopulateForm(el.shadowRoot)) {
          console.log('ShopifyFormsPrepopulate: Successfully prepopulated form.');
        }
      }
    };

    // Attempt immediately and after a delay
    tryFill();
    setTimeout(tryFill, 1500);

    const observer = new MutationObserver(() => {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(tryFill, 1000);
    });

    if (el.shadowRoot) {
      observer.observe(el.shadowRoot, { childList: true, subtree: true });
    }
  }

  function init() {
    console.log('ShopifyFormsPrepopulate: Initializing...');
    
    const check = () => {
      const el = document.querySelector('shopify-forms-embed');
      if (el) {
        observeShadow(el);
        return true;
      }
      return false;
    };

    if (!check()) {
      const obs = new MutationObserver((mutations, self) => {
        if (check()) self.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
